import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { TabMenu } from 'primereact/tabmenu';
import { MenuItem } from 'primereact/menuitem';
import { getAction } from '../../../appconfig/AppHelper';

export const DataFlowLetterTab = (initialTabLabel: any) => {
    const router = useNavigate();

    const [actions, setActions] = useState<any>([]);

    const HRitems: MenuItem[] = [
        {
            label: 'Data Flow Letter',
            command: () => {
                router('/app/letters/data-flow');
            }
        },
    ];

    const [activeIndex, setActiveIndex] = useState<number>(0);

    const filteredHRitems = HRitems.filter((item) => item.label && Object.prototype.hasOwnProperty.call(actions, item.label));

    // use Effect method
    useEffect(() => {
        setActions(getAction('Data Flow'));
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }, []);

    useEffect(() => {
        if (filteredHRitems.length > 0 && initialTabLabel) {
            const foundIndex = filteredHRitems.findIndex((item) => item.label == initialTabLabel.initialTabLabel);
            setActiveIndex(foundIndex >= 0 ? foundIndex : 0);
        }
    }, [actions, filteredHRitems]);

    return (
        <>
            <TabMenu model={filteredHRitems} activeIndex={activeIndex} onTabChange={(e) => setActiveIndex(e.index)} className="general-tab inner-tab " />
        </>
    );
};
